import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { EditIcon, AddIcon, ViewIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';
// Custom components
import TableWrapper from 'components/tableWrapper/tableWrapper';
import UserApi from '../../../../api/user';
import { useAuth } from '../../../../auth-context/auth.context';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import PageError from 'components/nopermission/PageError';

//Remove when API sends Data
export default function CheckTable(props) {
  const userType = 'ADMIN,SHOWROOM';
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  // const [data, setData] = useState([]);
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [role, setRole] = useState();
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(['']);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);
  const [fetchUserListError, setFetchUserListError] = useState(false);

  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  useEffect(() => {
    const permissions = getPermissionsForModule([Modules.AdminUser]);
    setPermissions(permissions);
  }, []);

  console.log('Permissions', permissions);

  const FetchUserList = async () => {
    try {
      setLoading(true);

      let response = await UserApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
        userType,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchUserListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
        // console.log(list);
      } else {
        setFetchUserListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchUserListError(true);
      console.log(err);
      setList([]);
    }
  };
  useEffect(() => {
    if (permissions?.read) {
      FetchUserList();
    }
  }, [permissions, searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  console.log('List conatis', list);
  const handleUpdate = async (onClose, id) => {
    try {
      const response = await UserApi.Update({
        id,
        name,
        email,
        phoneNumber,
      });
      console.log(response.data);
      if (response.data.status_code === 200) {
        toast({
          title: 'Successfully Updated',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        FetchUserList();
      } else if (response.data.statusCode === 0) {
        let error = response.data.responseData.error.name;
        toast({
          title: error,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (!permissions?.read) {
    return <NoPermissionsMessage module={Modules.AdminUser} />;
  }
  return fetchUserListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      mt='8rem'
      direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}>
        <Flex>
          <Input
            variant='auth'
            type='text'
            placeholder='Search Admin User..'
            onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
          />
        </Flex>

        <Flex ml='auto'>
          <Tooltip
            label={
              !permissions?.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren>
            <AddModal
              Icon={<AddIcon />}
              head={'Add Admin User'}
              func={FetchUserList}
              disabled={!permissions?.create}
            />
          </Tooltip>
        </Flex>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Sr.no
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Name
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  User Type
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  E-mail
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>

              <Th borderColor={borderColor}>
                <Flex
                  justify='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.user_type}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.email}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        fontSize='sm'
                        fontWeight='700'
                        color={
                          obj.status === 'ACTIVE'
                            ? 'green'
                            : obj.status === 'INACTIVE'
                              ? 'red'
                              : { textColor }
                        }>
                        {obj.status}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex
                      justify='center'
                      gap={1}>
                      <Tooltip
                        label={
                          !permissions?.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren>
                        <EditModal
                          Icon={<EditIcon />}
                          head={'Update Admin User'}
                          func={FetchUserList}
                          currentUser={obj}
                          disabled={!permissions.update}
                        />
                      </Tooltip>
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/adminuser/${obj?.id}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
